import React, { Fragment, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { db } from "../../../../firebase";
import {
  collection,
  query,
  orderBy,
  where,
  and,
} from "firebase/firestore";

import PageTitle from "../../../layouts/PageTitle";
import StockLogsItem from "./StockLogsItem";

import { usePagination } from "../../../../hook/usePagination";
import { useQuery } from "../../../../hook/useQuery";

const StockLogsList = () => {
  const [logList, setLogList] = useState([]);
  const [typeFilter, setTypeFilter] = useState("");
  const [itemTypeFilter, setItemTypeFilter] = useState("");

  const history = useHistory();
  const searchParams = useQuery();
  const param = searchParams.get("q");

  const searchRef = useRef(null);

  // Build query based on filters
  let QueryFilterConstraint = [];
  let queryRef = query(
    collection(db, "stockLogs"),
    orderBy("createdAt", "desc")
  );

  if (typeFilter || itemTypeFilter || param) {
    if (typeFilter) {
      QueryFilterConstraint.push(where("type", "==", typeFilter));
    }
    if (itemTypeFilter) {
      QueryFilterConstraint.push(where("itemType", "==", itemTypeFilter));
    }
    if (param) {
      QueryFilterConstraint.push(
        where("itemName", ">=", param),
        where("itemName", "<=", param + "\uf8ff")
      );
    }

    if (QueryFilterConstraint.length > 0) {
      queryRef = query(
        collection(db, "stockLogs"),
        and(...QueryFilterConstraint),
        orderBy("createdAt", "desc")
      );
    }
  }

  const {
    items: stockLogInfo,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
    totalPages,
    currentPage,
    goToPage,
  } = usePagination(queryRef, { limit: 20 });

  const handleSearchChange = () => {
    history.replace({
      search: new URLSearchParams({ q: searchRef.current.value }).toString(),
    });
  };

  useEffect(() => {
    setLogList(stockLogInfo);
  }, [stockLogInfo]);

  return (
    <Fragment>
      <PageTitle activeMenu="Stock Logs" motherMenu="Sales" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-center flex-wrap">
        {/* Type Filter */}
        <select
          className="form-control mr-2"
          style={{ maxWidth: "180px" }}
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
        >
          <option value="">All Types</option>
          <option value="add">add</option>
          <option value="return">return</option>
          <option value="adjust">adjust</option>
          <option value="sell">sell</option>
          <option value="withdraw">withdraw</option>
          <option value="material_issue">material_issue</option>
        </select>

        {/* Item Type Filter */}
        <select
          className="form-control mr-2"
          style={{ maxWidth: "160px" }}
          value={itemTypeFilter}
          onChange={(e) => setItemTypeFilter(e.target.value)}
        >
          <option value="">All Item Types</option>
          <option value="Accessory">Accessory</option>
          <option value="CPAP">CPAP</option>
        </select>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Item Name"
            onChange={handleSearchChange}
            ref={searchRef}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>

      <StockLogsItem
        items={logList}
        getPrev={getPrev}
        getNext={getNext}
        isStart={isStart}
        isEnd={isEnd}
        totalPages={totalPages}
        currentPage={currentPage}
        goToPage={goToPage}
      />
    </Fragment>
  );
};

export default StockLogsList;
